import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const CASAVI_SYNC_RESOURCE = "casavi-sync" as const;
export const CASAVI_SYNC_API_PATH = `/v1/${CASAVI_SYNC_RESOURCE}` as const;

export type CasaviSyncResponse =
  paths[typeof CASAVI_SYNC_API_PATH]["post"]["responses"][202]["content"]["application/json"];

export const useCasaviSyncMutation = () => {
  return useMutation<CasaviSyncResponse, Error, void>({
    mutationFn: async () => {
      const response = await alphartisApiAxios.post<CasaviSyncResponse>(CASAVI_SYNC_API_PATH);
      return response.data;
    },
  });
};
